import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useLandingStore = create(
	persist(
		(set) => ({
			platform: null,
			currentPage: null,
			status: { page1: false, page2: false, page3: false },
			pageData: null,
			mainData: null,
			currentSection: null,
			originProducts: null,

			setPlatform: (platform) => set({ platform: platform }),
			setCurrentPage: (page) => set({ currentPage: page }),
			setStatus: (status, page) =>
				set((state) => ({
					...state,
					status: { ...state.status, [page]: status },
				})),
			setPageData: (data) => set({ pageData: data }),
			setMainData: (data) => set({ mainData: data }),
			setCurrentSection: (data) => set({ currentSection: data }),
			setOriginProducts: (products) => set({ originProducts: products }),
			resetLandingStore: () =>
				set({
					platform: null,
					currentPage: null,
					status: { page1: false, page2: false, page3: false },
					pageData: null,
					mainData: null,
					currentSection: null,
					originProducts: null,
				}),
		}),

		{
			name: 'landing-storage',
			getStorage: () => sessionStorage,
		},
	),
);

export default useLandingStore;
